import { questRoles } from './quest';
import { archivesRoles } from './archives';
import { verificationsRoles } from './verifications';
import { USAARoles } from './usaa';
import { FeatureCodes } from '../features';

// // Top level / SuperAdmin feature permissions
// const CommonFeaturePermissions = {
//   MayViewAllJobs: 'MVAJ',
//   MayViewAllDrafts: 'MVAD',
// };

export const notificationPermissions = {
  MayViewNotifications: 'A-MVN',
  MayCreateNotifications: 'A-MCN',
  MayUpdateNotifications: 'A-MUN',
  MayDeleteNotifications: 'A-MDN',
};

const adminRoles = {
  name: 'App-Admin',
  permissions: {
    MayViewLogsPage: 'A-MVLP',
    ...notificationPermissions,
  },
};

const notificationsRole = {
  name: 'Notifications-Viewer',
  permissions: {
    MayViewNotifications: 'N-MVN',
  },
};

const userAccountRole = {
  name: 'User-Account',
  permissions: {
    MayViewUserProfile: 'UA-MVUP',
    MayEditUserProfile: 'UA-MEUP',
  },
};

export const AppRoles = {
  global: {
    SuperAdmin: {
      name: 'Super-Admin',
    },
  },
  [FeatureCodes.AscendQuest]: questRoles,
  [FeatureCodes.AscendArchives]: archivesRoles,
  [FeatureCodes.AscendVerifications]: verificationsRoles,
  [FeatureCodes.AscendUSAA]: USAARoles,
  [FeatureCodes.Admin]: adminRoles,
  [FeatureCodes.Notifications]: notificationsRole,
  [FeatureCodes.UserAccount]: userAccountRole,
} as const;
